var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 0a1 1 0 0 1 1 1v1h3a2 2 0 0 1 2 2v12.632a1 1 0 0 1-.294.708l-6.386 6.368a1 1 0 0 1-.706.292H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3V1a1 1 0 1 1 2 0v1h8V1a1 1 0 0 1 1-1zm4 8.018H3V22h10.982v-6a1 1 0 0 1 .883-.993l.117-.007H21V8.018zM20 17h-4v4l4-4zm-10-3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cb8b335afc9d0d7d3ea8974f8a2eba94.svg";
export { ForwardRef as ReactComponent };